export enum ROUTE_PATH {
  ROOT = '/',
  INSURED_HISTORY = 'insured-history',
  CORRESPONDENCES = 'correspondences',
  NOTIFICATIONS = 'notifications',
  CONTRIBUTIONS = 'contributions',
  DISABILITY = 'disability',
  CERTIFICATES = 'certificates',
  INSURANCE_CLEARANCE_CERTIFICATION = 'insurance-clearance-certification',
  IRIS_PAYMENT_HISTORY = 'iris-payment-history',
  UNAUTHORIZED = '401',
  // MOBILE ONLY
  SERVICES = 'services',
  SETTINGS = 'settings',
  // redirect route for common services home
  SSP_COMMON_SERVICES_HOME = '/ssp.commonservices.home/views/secure/index.xhtml'
}
